import CssBaseline from "@mui/material/CssBaseline";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
// GLOBAL CUSTOM HOOKS
import useSettings from "app/hooks/useSettings";

export default function ExpTheme({ children }) {
	const { settings } = useSettings();
	const activeTheme = { ...settings.themes[settings.activeTheme] };

	return (
		<ThemeProvider theme={activeTheme}>
			<CssBaseline />
			{children}
		</ThemeProvider>
	);
}
